<template>
	<div id="useradd">
		<div class="bm_h">
			<h3>用户基本信息</h3>
		</div>
		<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
			<Row type="flex" justify="center" align="middle">
				<FormItem label="用户名" prop="userLoginId">
					<Input v-model="formValidate.userLoginId" disabled  ></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="邮箱" prop="userEmail">
					<Input v-model="formValidate.userEmail" placeholder="请输入邮箱"></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="昵称" prop="otherName">
					<Input v-model="formValidate.otherName" placeholder="请输入昵称"></Input>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="省份" prop="provinceCode">
					<!-- :label-in-value="true" 方法checkDataChange 能获得value和label 没有则只能获得value -->
					<Select v-model="formValidate.provinceCode" placeholder="请选择省份" :label-in-value="true"
						@on-change="checkDataChange">
						<Option v-for="(item,index)  in provinces" :value="item.cityCode" :label="item.cityName"
							:key="index">{{item.cityName}}
						</Option>
					</Select>
				</FormItem>
			</Row>
			<Row type="flex" justify="center" align="middle">
				<FormItem label="城市" prop="cityCode">
					<Select v-model="formValidate.cityCode" placeholder="请选择城市" :label-in-value="true"
						@on-change="checkCityChange">
						<Option v-for="(item1,index)  in cityList" :value="item1.cityCode" :label="item1.cityName"
							:key="index">
							{{item1.cityName}}
						</Option>
					</Select>
				</FormItem>
			</Row>
			<Row justify="center" align="middle">
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 20px">重置</Button>
				</FormItem>
			</Row>
		</Form>
	</div>
</template>




<script>
	import {
		getCurentInfo,
		updateMyUserInfo,
		getXyCityCode
	} from '@/network/index.js';
	import intiHeadImage from "@/assets/image/element/headPhoto/1.png";


	//查询省份的参数
	const paramter = {
		cityLevel: 1
	};
 
	let provinceName;
	let cityName;
	
	let userType;
 

	export default {
		name: 'UserInfo',
		components: {

		},
		data() {
 
			return {
				formValidate: {
					userLoginId: '',
					otherName: '',
					userEmail: '',
					provinceCode: '',
					provinceName: '',
					cityCode: '',
					cityName: '',
				},
                userType,
				verificationImg: '',
				paramter,
				provinces: [],
				cityList: [],
				ruleValidate: {
					userLoginId: [{
						required: true,
						trigger: 'blur' //失去焦点事件
					}],
					userEmail: [{
							required: true,
							message: '邮箱是必填项',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '邮箱格式不对',
							trigger: 'blur'
						}
					],
					provinceCode: [{
						message: '请选择省份',
						trigger: 'change'
					}],
					cityCode: [{
						message: '请选择城市',
						trigger: 'change'
					}],

				}
			}
		},


		created() {
			//获取当前登录用户信息   
			//debugger;
			let paramterTemp = {
				userLoginId: this.$store.state.userInfo.loginId
			}
			getCurentInfo(paramterTemp).then(res => {
					this.formValidate.userLoginId  = res.data.obj.userLoginId;
					this.formValidate.userEmail = res.data.obj.userEmail;
					this.formValidate.otherName = res.data.obj.otherName;
					 
				 
					this.formValidate.provinceCode = res.data.obj.provinceCode;
					this.formValidate.provinceName = res.data.obj.provinceName;
					
					let parCity = {
						parentCode: res.data.obj.provinceCode,
					}
					this.getCity(parCity);
					
					this.formValidate.cityCode = res.data.obj.cityCode;
					this.formValidate.cityName = res.data.obj.cityName;
					
	 
				})
				.catch(error => {});

			//获取省市的数据
			getXyCityCode(paramter).then(res => {
					for (var i = 0; i < res.data.obj.dataList.length; i++) {
						this.provinces.push({
							cityCode: res.data.obj.dataList[i].cityCode,
							cityName: res.data.obj.dataList[i].cityName
						});

					}

				})
				.catch(error => {});





		},

		methods: {

			checkCityChange(val) {
				cityName = val.label; //获取label
			},
			getCity(val){
				getXyCityCode(val).then(res => {
						//先清空一下数据，否则之前加载的数据也在 
						this.cityList = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							//this.cityList.clear();
							this.cityList.push({
								cityCode: res.data.obj.dataList[i].cityCode,
								cityName: res.data.obj.dataList[i].cityName
							});
						}
				
					})
					.catch(error => {
				
					});
			},
			checkDataChange(val) {
				provinceName = val.label; //获取label
				let parentCodeTemp = val.value; //获取value
				let parCity = {
					parentCode: parentCodeTemp,
				}
				this.getCity(parCity);
			},
			
			
			 

			handleSubmit(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {
						
						let formdata = {
							userLoginId: this.formValidate.userLoginId,
							otherName: this.formValidate.otherName,
							userEmail: this.formValidate.userEmail,
							provinceCode: this.formValidate.provinceCode,
							provinceName: provinceName,
							cityCode: this.formValidate.cityCode,
							cityName: cityName,
							 
						};

						updateMyUserInfo(formdata).then(res => {
								console.log('res:' + res);
								 this.$Message.success('修改成功!');
							})
							.catch(error => {
								this.$Message.success('修改失败，请联系管理员!');
							});


					} else {
						this.$Message.error('数据校验失败，请修改后重新提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bm_h {
		padding: 0 10px;
		height: 50px;
		border-top: 1px solid #FFF;
		border-bottom: 1px solid #e3e2db;
		background: #F2F2F2;
		line-height: 50px;

	}


	.ivu-input-wrapper {
		width: 300px;

	}

	.ivu-form-item-label {
		text-align: center;
	}

	.ivu-form-item-content {
		text-align: left;
	}

	.ivu-select {
		width: 300px;
	}



	#weixin {
		line-height: 20px;
		top: 10px;
		left: 10px;
		position: absolute;
	}

	#weixin-logo {
		width: 30px;
		height: 30px;
		border-radius: 3px; //添加圆角
	}

	#weixin-word {
		width: 60px;
		height: 20px;
		position: relative;
		left: 300px;
	}

	// #head {
	// 	line-height: 20px;
	// 	top: 42px;
	// 	left: 10px;
	// 	position: relative;
	// }

	#head-logo {
		width: 60px;
		height: 60px;
		border-radius: 3px; //添加圆角
		//position: relative;
		//left: 300px;

	}

	#head-select {
		width: 200px;
		height: 30px;
		bottom: 20px;
		border-radius: 1px; //添加圆角
		position: relative;
		left: 300px;

	}

	label {
		position: relative;
	}

	#fileinp {
		position: absolute;
		left: 0px;
		top: 0;
		opacity: 0;
	}

	#btn {
		margin-right: 5px;
	}


	#head-word {
		width: 60px;
		height: 20px;
		position: relative;
		bottom: 25px;
		// top: 15px;
		left: 10px;
	}

	#imageId {
		width: 120px;
		height: 30px;
		position: absolute;
		left: 180px;
		top: 2px;
	}

	#useradd {
		border-style: solid;
		border-width: 1px;
		border-color: #bebdbc;
	}

	#noteWord {
		position: absolute;
		left: 61%;
		top: 47%;
	}
</style>
